import { api } from "./../constants";
import axios from "axios";

export default async function trackEvent(event: string, object: any = null) {
  await woogievent(event, object ?? {});
  await americauevent(event, object ?? {});
}

function woogievent(event: string, object: any) {
  object.name = event;

  return axios.post(
    "https://portal.americau.com/woogi/0.1/actor/cgi.php",
    {
      cmd: "WcTrackActivitySkillManage.saveHLPortal",
      event: event,
      source_version: "v3",
      props: object,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function americauevent(event: string, object: any) {
  object.name = event;

  let act_session = getCookie("activity_session");

  if (act_session) object.userCode = "cookie-" + act_session;

  // return axios.post(
  //   api + "/data",
  //   { data: object },
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   }
  // );
}

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts?.length === 2) return parts.pop()?.split(";").shift();

  return null;
}
